require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-raises-over-usd-20-000-for-charity-through-golf-outing.json") })
        }
      }, "path---articles-financial-center-raises-over-usd-20-000-for-charity-through-golf-outing");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-raises-over-usd-20-000-for-charity-through-golf-outing!./.cache/json/articles-financial-center-raises-over-usd-20-000-for-charity-through-golf-outing.json
// module id = 1663
// module chunks = 231608221292675